import { createAction } from '../util/actions';

export const setHeaderIsOpen = createAction('SET_HEADER_IS_OPEN');
